import { useGetOwnerDocuments } from "~/v2/api/hooks";

export const useGetID = (accountId: string, ownerId: string) => {
  const { documents: existingDocs, refetch } = useGetOwnerDocuments({
    accountId,
    ownerId,
    options: {
      enabled: !!ownerId,
    },
  });

  const passport = existingDocs?.find(
    (doc) =>
      doc.doc_type === "identity_verification" &&
      doc.doc_sub_type === "passport",
  );
  const front = existingDocs?.find(
    (doc) =>
      doc.doc_type === "identity_verification" && doc.doc_sub_type === "front",
  );
  const back = existingDocs?.find(
    (doc) =>
      doc.doc_type === "identity_verification" && doc.doc_sub_type === "back",
  );

  return {
    passport,
    front,
    back,
    refetch,
  };
};

export type UseGetIdReturn = ReturnType<typeof useGetID>;
